export default __webpack_public_path__ + "static/media/LightFixtures-Stacklab1642_.5e9b5677.jpg";